import { BiHeart } from 'react-icons/bi'

const Relation = ({relation, data}) => {

      if(relation.data) return 

      return (
            <div className="box_wrapper">
                  <div className="header_box__content">
                        <div className="header_content_icon">
                              <BiHeart />
                        </div>
                        <h3>{relation.relation_type}</h3>
                  </div>
                  <div className="box_content">
                        <div className="relation_wrapper">
                              <div className="relation_header">
                                    <div className="relation_header__avatar">
                                          <img src={relation.avatar === '' ? data.relation.avatar : relation.avatar} alt={relation.name === '' ? data.relation.name : relation.name} />
                                    </div>
                                    <div className="relation_header__infor">
                                          <h4>{relation.name === '' ? data.relation.name : relation.name}</h4>
                                          <span>{relation.id_xat === '' ? data.relation.id_xat : relation.id_xat}</span>
                                    </div>
                              </div>
                              <div className="relation_description">
                                    <p>{relation.about === '' ? data.relation.about : relation.about}</p>
                              </div>
                              <a href={relation.me === '' ? data.relation.me : relation.me} target="_blank" rel="noreferrer">xat.me</a>
                        </div>
                  </div>
            </div>
      )
}

export default Relation